import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';
import { PropertyRow } from '@/shared/components/ui/PropertyRow';
import { UserTeamSelect } from '@/shared/components/user-team-select/UserTeamSelect';
import type { UsersAndTeams } from '@momentum/types';

interface RelevantPartiesFieldProps {
  value: UsersAndTeams;
  onChange: (value: UsersAndTeams) => void;
}

export const RelevantPartiesField = ({
  value,
  onChange,
}: RelevantPartiesFieldProps) => {
  const { t } = useTranslation('knowledge');

  return (
    <PropertyRow
      icon={<Users />}
      label={t('relevantPartiesLabel')}
      tooltip={t('relevantPartiesTooltip')}
    >
      <UserTeamSelect
        value={value}
        onChange={onChange}
        placeholder={t('relevantPartiesPlaceholder')}
        teamsLabel={t('pickerTeamsGroup')}
        peopleLabel={t('pickerPeopleGroup')}
        searchPlaceholder={t('pickerSearchPlaceholder')}
        noResultsLabel={t('pickerNoResults')}
      />
    </PropertyRow>
  );
};
